module.exports = __webpack_public_path__ + "img/Banner.9dbbbe75.png";